import { Component, OnInit, ViewChildren, QueryList, Input, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from '../../../../../../types/rxjs';
import { PodcastGroup, Podcast } from '../../../../data/podcast-client-api/model/podcastContent';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

declare var $: any;
declare var Glider: any;

@Component({
  selector: 'app-podcast-carousel',
  templateUrl: './podcast-carousel.component.html',
  styleUrls: ['./podcast-carousel.component.css']
})


export class PodcastCarouselComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() carouselID: number;
  @Input() last: boolean;
  @Input() data: PodcastGroup;
  @ViewChildren('podcastItems') podcastItems: QueryList<any>;

  private changeSubscription: Subscription;
  podcastCarousel: any;
  podcasts: Podcast[] = [];
  isDesktop: boolean;

  constructor(
    private router: Router,
    private deviceService: DeviceDetectorService,
    private cdRef: ChangeDetectorRef,

  ) {
    this.isDesktop = this.deviceService.isDesktop();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.podcasts = this.data.podcastPS;
    this.carouselInit();
    this.cdRef.detectChanges();

  }



  carouselInit() {
    this.changeSubscription = this.podcastItems.changes.subscribe(t => {
      this.podcastCarousel = new Glider(document.querySelector('#podcast-carousel-' + this.carouselID), {
        slidesToScroll: 1,
        draggable: true,
        rewind: true,
        duration: 1.2,
        dragVelocity: 1,
        responsive: [
          {
            // screens greater than >= 1024px
            breakpoint: 1350,
            settings: {
              slidesToShow: 8.2,
              slidesToScroll: 1,
            }
          },
          {
            // screens greater than >= 1024px
            breakpoint: 1024,
            settings: {
              slidesToShow: 6.3,
              slidesToScroll: 1,
            }
          },
          {
            // screens greater than >= 1024px
            breakpoint: 767,
            settings: {
              slidesToShow: 5.3,
              slidesToScroll: 1,
            }
          },
          {
            // screens greater than >= 1024px
            breakpoint: 0,
            settings: {
              slidesToShow: 3.3,
              slidesToScroll: 1,
            }
          },
        ],
        arrows: {
          prev: '#podcast-glider-prev-' + this.carouselID,
          next: '#podcast-glider-next-' + this.carouselID,
        }
      });
    });

    setTimeout(() => {

      if (this.podcasts.length <= 8) {
        document.getElementById('podcast-glider-prev-' + this.carouselID).style.display = 'none';
        document.getElementById('podcast-glider-next-' + this.carouselID).style.display = 'none';
      }
    }, 300);

  }

  routeDetail(id: number) {
    if (!this.isDesktop) {
      this.router.navigateByUrl('podcastDetail/' + id);
    }
  }

  goPodcastGrid(id: number) {
    this.router.navigateByUrl('podcastGrid/' + id);
  }

  ngOnDestroy() {
    if (this.changeSubscription) {
      this.changeSubscription.unsubscribe();
    }
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/podcast/widgets/podcast-carousel/podcast-carousel.component.ts